<ng-container [ngSwitch]='vendorId'>
  <app-welcome-itm *ngSwitchCase='vendorIdConfig.itm'></app-welcome-itm>
  <app-welcome-otherVendor *ngSwitchCase='vendorIdConfig.mercer'></app-welcome-otherVendor>
  <app-welcome-otherVendor *ngSwitchCase='vendorIdConfig.oo'></app-welcome-otherVendor>
  <app-welcome-otherVendor *ngSwitchCase='vendorIdConfig.bennett'></app-welcome-otherVendor>
  <p *ngSwitchDefault>No Welcome Page found for the Vendor</p>
</ng-container>
